import { type ReactElement } from 'react';
import type { MapSpot, MapVenue, ReservationRequest } from '@kratispot/shared';
import { DIALOG_BASE, DIALOG_CARD, DIALOG_FULL } from '@/components/map/dialog-frame';
import { ReserveForm } from '@/components/map/reserve-form';
import { useScrollLock } from '@/hooks/use-scroll-lock';
import { useFullScreen } from '@/hooks/use-full-screen';
import { useTranslation } from '@/lib/i18n';
import { cn } from '@/lib/utils';

// The bulk dialog: one guest over a whole selection, from the Select bar or a
// calendar cell. A single spot books from its own dialog instead. §10
export function ReserveModal({
  venue,
  spots,
  date,
  today,
  nowMinutes,
  busy,
  refused,
  onClose,
  onDropSpot,
  onSubmit,
}: {
  venue: MapVenue;
  spots: readonly MapSpot[];
  date: string;
  today: string;
  nowMinutes: number;
  busy: boolean;
  refused: string | null;
  onClose: () => void;
  onDropSpot: (spot: MapSpot) => void;
  onSubmit: (request: ReservationRequest) => void;
}): ReactElement {
  const { t } = useTranslation();
  useScrollLock();
  const full = useFullScreen();
  return (
    <>
      <button
        type="button"
        aria-label={t('close')}
        onClick={onClose}
        className="fixed inset-0 z-70 cursor-default bg-black/40"
      />
      <ReserveForm
        venue={venue}
        spots={spots}
        date={date}
        today={today}
        nowMinutes={nowMinutes}
        busy={busy}
        refused={refused}
        dialogLabel={t('newReservation')}
        nameSpots
        drop={{ label: t('dropSpot'), onDrop: onDropSpot }}
        className={cn(DIALOG_BASE, full ? DIALOG_FULL : DIALOG_CARD)}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    </>
  );
}
